module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_XIX"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XIX"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH")]), _vm._v(", L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMENTATIONS")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Jeremiah_book"
    }
  }, [_vm._v("When one enters the world of the church fathers, it is a horizon defined by the sacred Scriptures of the Old and New Testaments. From creation to consummation, from the beginning of time to its ending, the Fathers defined reality with the vocabulary and claims of these sacred texts. They received the canon as a coherent and accurate description of God’s actions and of humanity’s place in the world. More precisely, they viewed these texts through an authoritative lens, namely, the apostolic portrayal of Christ and his meaning for all of history.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Jeremiah_book"
    }
  }, [_vm._v("The Fathers were continually challenged in their ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_interpretation"
    }
  }, [_vm._v("interpretation and use of sacred Scripture. From the Judaizers (Galatians) to the early Gnostics to Marcion, each generation was called to articulate the faith by interpreting the sacred Scriptures in the face of those who were misappropriating texts through novelty or falsehood. For example, ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Athanasius"
    }
  }, [_vm._v("Athanasius’s dispute with ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Arius"
    }
  }, [_vm._v("Arius was permeated by exegetical differences on which questions rested the very nature of Christ.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Arius"
    }
  }, [_vm._v("To be faithful to the apostolic witness was central to the vocation of the Fathers.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP1",
      "id": "ap_NBP1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Moreover, it was their conviction that the apostolic hermeneutic was itself the gift of the earthly and now risen Christ: “I have said these things while I am still with you. But the Advocate, the Holy Spirit, whom the Father will send in my name, will teach you everything, and remind you of all that I have said to you.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP2",
      "id": "ap_NBP2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The Fathers would concur with a classic study on the apostles’ use of the Old Testament that concludes:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("The Christian church was founded on this distinctive and revolutionary use of the Old Testament. With regard to those passages of the Old Testament whose use we have specifically studied in this chapter, we have found, despite a considerable difference of emphasis, an almost unbroken agreement with both the exegesis and the application of Jesus. . . . Apart from the book of Revelation, moreover, there is no significant dependence on current Jewish use of the Old Testament. The school in which the writers of the early church learned to use the Old Testament was that of Jesus."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP3",
      "id": "ap_NBP3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("It should also be noted that for all their imaginative and intellectual capacities, the Fathers remained pastors. Their use of the sacred Scriptures was not the abstract debate of the academy but the concrete pastoral care and nurture of the church. Hence, their use of the Old and "), _c('a', {
    attrs: {
      "id": "page_XX"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XX"
    }
  }, [_vm._v("New Testaments is shaped by churchly needs. Homilies, catechesis, apologetic and liturgy are prominent. Even the few commentaries are deeply pastoral in that their exposition addresses the church’s life.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP4",
      "id": "ap_NBP4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("If modern readers find it difficult to enter the biblical world and to think in its categories, the church fathers provide a helpful entry point. The obfuscating veils of the Enlightenment, modernity and postmodernism did not cloud their vision.")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("As products of the Enlightenment modernity, contemporary readers are often limited by late twentieth century interpretations of Scripture. Yet this has not always been so. Long before the rise of historical-critical methods of biblical interpretation the church unabashedly read the Bible through the eye of faith, with uncommon spiritual and devotional insight."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP5",
      "id": "ap_NBP5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This hermeneutical clarity and openness to scriptural categories are great gifts that the church fathers offer us. Our capacity to think biblically will be enhanced by time spent in their company. Far from being ancient esoterica, these texts can enrich the thought and lives of Christians today.")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("The Christian Bible (the Greek Old Testament and the apostolic writings) create a distinctive universe of meaning. As its words took up residence in the minds and hearts of Christian thinkers, it gave them a vocabulary that subtly shaped their patterns of thought. . . . For early Christian thinkers the Bible, finally, was a book about how to live. God’s word is not something to be looked at but acted on."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP6",
      "id": "ap_NBP6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In their use of Scripture in preaching and in pastoral care the church fathers were following the biblical witness in Moses’ preaching and instruction as well as the voice of the prophets in admonition and encouragement for the faithful in Israel."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP7",
      "id": "ap_NBP7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-023"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_characteristics"
    }
  }, [_vm._v("History of Jeremiah and Lamentations")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_characteristics"
    }
  }, [_vm._v("Jeremiah occupies a distinctive place among the prophets of Israel. The prophetic corpus credited to him is not only the largest in the Old Testament canon but also provides detailed accounts of his life and experiences at a key moment in Israel’s history. The French scholar ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Ridouard"
    }
  }, [_vm._v("André Ridouard has written: “Prophetism taken as a whole constitutes a sort of backbone of the Old Testament. . . . Now the prophet par excellence, the one who can allow us to surmise to some degree the experience lived by those men and their role in history, is indisputably Jeremiah.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP8",
      "id": "ap_NBP8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Jeremiah’s signature was a call to repentance. God’s definition of his mission was clear.")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('a', {
    attrs: {
      "id": "page_XXI"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XXI"
    }
  }, [_vm._v("And I for my part have made you today a fortified city, an iron pillar, and a bronze wall, against the whole land—against the kings of Judah, its princes, its priests, and the people of the land. They will fight against you; but they shall not prevail against you, for I am with you, says the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", to deliver you.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP9",
      "id": "ap_NBP9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This call to prophecy came in 627 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")]), _vm._v(" and launched Jeremiah into the challenges of Israel’s critical religious and historical context. His message was a call to return to Yahweh, to the Torah and to covenant stipulations."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP10",
      "id": "ap_NBP10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Jeremiah’s ministry covered the tumultuous decades that offered brief hope in the reform of Josiah (622 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C")]), _vm._v(".) but tragically ended in widespread apostasy and the fall of Jerusalem in 586 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C. ")]), _vm._v("His life as well as his message displayed God’s word to a wayward people. God constrained him to remain single"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP11",
      "id": "ap_NBP11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" and to engage in a number of symbolic actions to exhibit the call to repentance. On several occasions his life was endangered by offended parties from King Jehoiakim to his fellow townspeople in Anathoth. Our last word about him places him reluctantly in Egypt as a group had taken him there to escape further Babylonian reprisals.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Jeremiah’s influence and role in the "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_pseudepigrapha"
    }
  }, [_vm._v("pseudepigrapha of the Second Temple period as well as the ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Qumran_scrolls"
    }
  }, [_vm._v("Qumran scrolls are interesting.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP12",
      "id": "ap_NBP12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" While the Qumran community cites Jeremiah sparingly (Hodayoth—1HQ), textual readings are extant (see “the text”). Noteworthy, however, are the number of early Jewish works associated with Jeremiah. The "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Paralipomena"
    }
  }, [_c('i', [_vm._v("Paralipomena of Jeremiah ")]), _vm._v("and the ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Vita_Jeremiah"
    }
  }, [_c('i', [_vm._v("Vita of Jeremiah")]), _vm._v(" (second or third century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.D.)")]), _vm._v(" as well as material in ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Eupolemos"
    }
  }, [_vm._v("Eupolemos, ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Philo"
    }
  }, [_vm._v("Philo and the Talmud exhibit the influence of Jeremiah on Jewish tradition.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP13",
      "id": "ap_NBP13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("In the New Testament, Jeremiah is mentioned three times by name. Of special interest is Matthew 16:13-14: “Now when Jesus came into the district of Caesarea Philippi, he asked his disciples, ‘Who do people say that the Son of Man is?’ They said, ‘Some say John the Baptist, but others Elijah, and still others Jeremiah or one of the prophets.’” Scholars have speculated about this linkage of Jeremiah to Jesus’ ministry. Jesus’ teaching concerning the coming judgment of Jerusalem may have recalled Jeremiah’s words."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP14",
      "id": "ap_NBP14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Jeremiah was perceived as a prophet to the nations, as was Jesus."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP15",
      "id": "ap_NBP15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Jeremiah is also mentioned by name at Matthew 2:17 and Matthew 27:9 in conjunction with the prophecies of the murder of the innocents in Bethlehem"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP16",
      "id": "ap_NBP16-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" and Judas’s betrayal of Jesus."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP17",
      "id": "ap_NBP17-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_XXII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XXII"
    }
  }, [_vm._v("Apart from the explicit mention of Jeremiah’s name, however, his message of the new covenant (Jer 31:31-34) provides a rich source of exposition for the New Testament authors: Hebrews 8:8-12, Hebrews 10:16-17 and 2 Corinthians 3:5-6.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XXII"
    }
  }, [_vm._v("The earliest Jewish witnesses to the canon unanimously include Jeremiah.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP18",
      "id": "ap_NBP18-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Further, the congruence of the Old Testament canon and the Hebrew Scriptures in the Jewish and Christian communities of the first century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.D")]), _vm._v(". was very close: “Christian evidence from the New Testament period endorses various Jewish titles for the canon, the three-fold Jewish structure, the traditional Jewish order for the books, and possibly one of the two standard Jewish numerations of the books.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP19",
      "id": "ap_NBP19-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Lamentations"
    }
  }, [_vm._v("Lamentations, closely associated with the prophet, enjoyed the same canonical history and status.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-024"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Lamentations"
    }
  }, [_vm._v("The Fathers’ Use of Jeremiah")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Lamentations"
    }
  }, [_vm._v("If one surveys the use of Jeremiah in the patristic period, it is noteworthy that the earliest, the ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Apostolic_Fathers"
    }
  }, [_vm._v("Apostolic Fathers, rarely cite Jeremiah.")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Apostolic_Fathers"
    }
  }, [_vm._v("The apostolic fathers showed remarkably little interest in Jeremiah. Unlike their early Jewish counterparts they did not develop the themes of judgment and restoration central to the book, since the destruction of the Jerusalem Temple in 70 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("C.E")]), _vm._v(". had less direct impact on the gentile Christian community. If a particular motif in Jeremiah was used, it was the critique of Israel’s sacrificial cult in 7:21-23, cited along with other biblical passages in ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Barnabas"
    }
  }, [_c('i', [_vm._v("The Epistle of Barnabas")]), _vm._v(" 2.5-8 to demonstrate the superiority of the Christian faith over the Jewish religion.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP20",
      "id": "ap_NBP20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("At the same time, several later authors are prominent for the extent of their commentary and appropriation of Jeremiah:")]), _c('ul', {
    staticClass: "liste_none"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("• "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Origen"
    }
  }, [_vm._v("Origen (185-254). Twenty homilies in Greek are available and fourteen extant in Latin that were delivered by Origen when he was in his fifties. They provide another side of Origen, of one who was not only an academic and an exegete but also responding to crises within his own community and trying to provide a context for dealing with some of his own theological struggles. They nonetheless also provide us with a virtual catechism of his views on Christian doctrine and philosophy. Jeremiah had arrived on the scene in Israel at a crucial time in its history, the time of its captivity by Babylon. Origen too was writing at a critical time in the life of the Christian church, during its persecution by Rome. Thus, we see themes of conversion, repentance, judgment, spiritual progress, the power of evil, the meaning of salvation and the role of Christ as recurrent themes in his homilies.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP21",
      "id": "ap_NBP21-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_XXIII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XXIII"
    }
  }, [_vm._v("• ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Theodoret"
    }
  }, [_vm._v("Theodoret of Cyr (393-460). His commentary on Jeremiah, ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Baruch"
    }
  }, [_vm._v("Baruch and Lamentations")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP22",
      "id": "ap_NBP22-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" is considered as one literary unit. Comments on Jeremiah comprise the first ten books of commentary, grouped together with his commentary on Baruch, which is book eleven, and his commentary on Lamentations, which is book twelve. These commentaries are by and large focused on a literal and typological "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_interpretation2"
    }
  }, [_vm._v("interpretation. Often his comments seem simply to repeat the text, but they often provide helpful exegetical and hermeneutical material that aids the interpreter in explicating the text. When he does engage in typological interpretations, the poignancy of his observations cannot be ignored.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_interpretation2"
    }
  }, [_vm._v("• ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Jerome"
    }
  }, [_vm._v("Jerome (345-420). His commentary on Jeremiah was written near the end of his life. He had wanted to write a commentary on the entire book but was only able to complete six books on the first thirty-two chapters. Although the commentary covers only thirty-two of Jeremiah’s fifty-two chapters, it contains several interesting features. There is an increasing emphasis by Jerome on the Hebrew text, arguing that the Septuagint text is sporadically unreliable, having been corrupted by copyists ("), _c('i', [_vm._v("Commentary on Jeremiah")]), _vm._v(" 17.1-4). Also interesting is the fact that Jerome criticizes his former hero, Origen, severely. This is probably because of the Pelagians (who considered themselves to be the disciples of Origen) against whose beliefs Jerome wrote a treatise at this time entitled ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Dialogue"
    }
  }, [_c('i', [_vm._v("Dialogue Against the Pelagians")]), _vm._v(".")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP23",
      "id": "ap_NBP23-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" A third point of interest in this commentary is Jerome’s concentration on a straightforward, literal interpretation of the text rather than on allegorical exegesis. This may be in part because he was writing for his friend "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Eusebius"
    }
  }, [_vm._v("Eusebius of Cremona, who preferred the literal sense.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP24",
      "id": "ap_NBP24-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("• Authors who provide "), _c('i', [_vm._v("catenae")]), _vm._v(" from Jeremiah include "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Cyril"
    }
  }, [_vm._v("Cyril of Alexandria (375-444)")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP25",
      "id": "ap_NBP25-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" and "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Ephrem"
    }
  }, [_vm._v("Ephrem (303-373). In Ephrem’s case we have chosen to use his "), _c('i', [_vm._v("Commentary on Jeremiah,")]), _vm._v(" which is extant only in a Syriac translation.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP26",
      "id": "ap_NBP26-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("• A pseudonymous commentary, credited to "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_John"
    }
  }, [_vm._v("Chrysostom (347-407), is extant, but we have not made any selections from this commentary.")])])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_John"
    }
  }, [_vm._v("In addition to these longer expositions, Jeremiah provides a dense resource of motifs and texts for the pastoral and theological challenges that the fathers of the early church faced. ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Justin"
    }
  }, [_vm._v("Justin and ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Irenaeus"
    }
  }, [_vm._v("Irenaeus appeal to Jeremiah 2:12-13 to define Christians over against Jews and heretics. ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Athanasius2"
    }
  }, [_vm._v("Athanasius used Jeremiah 2:13 in the trinitarian debates. In the ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_trinitarian"
    }
  }, [_vm._v("trinitarian controversy, Athansius ")]), _c('a', {
    attrs: {
      "id": "page_XXIV"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XXIV"
    }
  }, [_vm._v("would cite Jeremiah 2:13 of the Father: “the fountain of living water.” Since the Son is life,")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP27",
      "id": "ap_NBP27-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" it is absurd for the "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Arians"
    }
  }, [_vm._v("Arians to suppose that “there was when he was not.” This would make the Father a dry fountain, void of life.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP28",
      "id": "ap_NBP28-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Jerome viewed Jeremiah’s prophecy of the destruction of Jerusalem and the return as preliminary and typical:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Jerome repeatedly stressed the dual and even triple significance of the way in which the prophets describe Israel’s restoration. Looking, in an initial and perfect way, at the Jewish people’s return to the Holy Land after the Babylonian exile, the prophets had mainly in mind, through this return, both Christ’s first coming, with the time of the Church, and also his second coming. The prophecy in Jeremiah 31:8 (“See, I am going to bring them from the land of the north, and gather them from the farthest parts of the earth . . . ”) is presented as having been fulfilled only in typical fashion, and not in truth, at the time of the return from Babylon to Jerusalem under Ezra, “for it was not then that everything we read was accomplished,” and the Jews cannot prove that the prophecies were truly fulfilled at that time. These prophecies, “though accomplished literally and typically after the return from Chaldea, when the people came back to Judea under the orders of King Cyrus, were accomplished spiritually in Christ and the Apostles, more truly and more fully."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP29",
      "id": "ap_NBP29-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("A number of Fathers denounce immorality by referring to Jeremiah 5:8 with its description of lustful stallions ("), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Cyril2"
    }
  }, [_vm._v("Cyril of Jerusalem "), _c('i', [_vm._v("Catechetical Lectures ")]), _vm._v("9.13"), _c('i', [_vm._v("; ")]), _vm._v("Irenaeus"), _c('i')]), _c('i', [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Against_Heresies"
    }
  }, [_vm._v("Against Heresies ")])]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Against_Heresies"
    }
  }, [_vm._v("5.8.3). Positive appeals for appropriate behavior draw on Jeremiah 9:23-24 (Cyprian ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Treatise"
    }
  }, [_c('i', [_vm._v("Treatise ")]), _vm._v("12.3.10).")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP30",
      "id": "ap_NBP30-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("In a rich passage, Origen reflects on Jeremiah 20:7. He suggests that like a good father, God guides a child toward ultimate welfare though the immediate events may not indicate such ("), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Homelies_Jeremiah"
    }
  }, [_c('i', [_vm._v("Homilies on Jeremiah ")]), _vm._v("19, 20). Jeremiah 23:24 stimulates ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Gregory"
    }
  }, [_vm._v("Gregory of Nazianzus to explain the incomprehensible aspects of God’s character (")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Theological_Oration"
    }
  }, [_c('i', [_vm._v("Theological Oration ")]), _vm._v("2.8-11).")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Theological_Oration"
    }
  }, [_vm._v("Like the New Testament authors, Jeremiah 31:31-34, with its prophecy of a “new covenant,” provides a key resource for theological engagement. Irenaeus ("), _c('i', [_vm._v("Against Heresies ")]), _vm._v("4.9.1; 4.33.14), ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Cyprian"
    }
  }, [_vm._v("Cyprian ("), _c('i', [_vm._v("Treatise ")]), _vm._v("12.1.11) and ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Augustine"
    }
  }, [_vm._v("Augustine ("), _c('i')]), _c('i', [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Spirit"
    }
  }, [_vm._v("The Spirit and the Letter ")])]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Spirit"
    }
  }, [_vm._v("32-42) all draw on the theme of a new covenant to make decisive theological points.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Basil"
    }
  }, [_vm._v("Basil the Great and ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Clement"
    }
  }, [_vm._v("Clement of Alexandria viewed Jeremiah as a resource for ethical exhortation. Basil, especially, focused on the book’s moral and ethical aspects. He includes more than a passing reference in his homilies to the lusty stallions in Jeremiah 5:8, a phrase that was viewed ")]), _c('a', {
    attrs: {
      "id": "page_XXV"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XXV"
    }
  }, [_vm._v("by him and other writers as an allegorical image for unfaithful Israel")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP31",
      "id": "ap_NBP31-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" and was invoked in condemnation of sexual excesses. Similiarly, the mention of God’s nearness in Jeremiah 23:23 was read as an exhortation to base one’s behavior on the awareness that all actions are carried out in the presence of God (Basil "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Long_Rules"
    }
  }, [_c('i', [_vm._v("The Long Rules ")]), _vm._v("5).")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP32",
      "id": "ap_NBP32-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Lastly, Ambrose understood Jeremiah as a noble and righteous intercessor on behalf of the people.")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Jeremiah the prophet whom the Lord our God has told, “Do not pray for this people” (Jer 7:16), prayed despite that and gained forgiveness. Thus the urgent prayer of so great a seer, interceding in the capacity of a prophet, softened the Lord."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP33",
      "id": "ap_NBP33-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-025"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("The Fathers’ Use of Lamentations")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As might be expected, Lamentations became associated with losses and death ("), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Gregory2"
    }
  }, [_vm._v("Gregory of Nyssa "), _c('i')]), _c('i', [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Funeral"
    }
  }, [_vm._v("Funeral Oration on Meletius")])]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Funeral"
    }
  }, [_vm._v("). Lamentations also served the Fathers well as a description of the challenges that face the Christian in a fallen world (Lam 3:27-31).")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Funeral"
    }
  }, [_vm._v("Particularly prominent in the Fathers’ usage is Lamentations 4:20: “The Lord’s anointed, the breath of our life, was taken in their pits—the one of whom was said, ‘Under his shadow shall we live among the nations.’”")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Funeral"
    }
  }, [_vm._v("Lam 4:20 was an important text to early Christians. In addition to reading the text as referring to Christ as the believer’s spiritual food, early Christians would see the incarnation, cross, and passion prophesied in Lam 4:20. Since the nose, the organ of breathing, stands out from the face, ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Justin2"
    }
  }, [_vm._v("Justin believed a cross was traced in the center of the human visage. Thus Lam 4:20, “the breath of our nostrils is the Lord’s anointed,” anticipated Christ’s crucifixion for Justin (")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Apology"
    }
  }, [_c('i', [_vm._v("1 Apology")]), _vm._v(" 55.1-6). Irenaeus, too, would see the Lord’s passion in Lam 4:20, but he would emphasize both the reference to “breath” in 4:20a, which he translates “Spirit,” and the reference to “his shadow” in 4:20c. This combination of terms prophesied the bitter, veiling incarnation (shadow) of the Spirit Christ (")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Demonstration"
    }
  }, [_c('i', [_vm._v("Demonstration of the Apostolic Preaching")]), _vm._v(" 71). For Origen as well the passage spoke of the first advent of the Lord Christ, that humble incarnation (")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Homily_Joshua"
    }
  }, [_c('i', [_vm._v("Homily on Joshua ")]), _vm._v("8.6 [sic 8.4]). But the “shadow in which we live” could also refer to the mortality of the present age that clouded even the believer’s partial experience of immortality in this life (")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Matthew"
    }
  }, [_c('i', [_vm._v("Commentary on Matthew ")]), _vm._v("15.2). Again the Alexandrian would read it in a positive, yet guarded manner of the Christian’s present experience. “His shadow in which we live among the nations” is ")]), _c('a', {
    attrs: {
      "id": "page_XXVI"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XXVI"
    }
  }, [_vm._v("contrasted to the shadow of the Law in which the unredeemed live. In the shadow the believer has a share in Christ as the way, truth, and life, but it is dim. The believer still awaits a perfect, future redemption (")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_song"
    }
  }, [_c('i', [_vm._v("Commentary on the Canticles ")]), _vm._v("3).")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP34",
      "id": "ap_NBP34-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-026"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("The Text, Hebrew and Greek")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Jeremiah exhibits an interesting textual richness in the Hebrew and Greek traditions. There are approximately twenty-seven hundred words in the longer Hebrew/Masoretic text than in the Greek. This means that the Greek text is about one-eighth shorter than the Hebrew text. Scholars have suggested that this is equivalent to six or seven chapters that are absent from the Greek edition."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP35",
      "id": "ap_NBP35-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Further, there are several significant differences in the ordering of the text. The oracles against the nations are in a different order in the respective traditions. In the Hebrew tradition, the oracles are at the end; in the Greek tradition, they are in the middle. It is noteworthy that the Hebrew and Greek texts are quite close in the poetic sections, with the longer Hebrew texts appearing mostly in prose. Table 1 displays the different arrangement of material in the Hebrew ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT")]), _vm._v(") and Greek ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("LXX")]), _vm._v(") texts."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP36",
      "id": "ap_NBP36-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("There are a variety of scholarly views, but a recent study suggests that the Greek text preserves the more ancient reading."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP37",
      "id": "ap_NBP37-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" A significant development in the analysis of the differences between the Hebrew and Greek texts is new evidence from the Qumran scrolls. “It now seems clear from Qumran that both the longer and the shorter forms of the text were available in the Qumran community and that the Masoretic Text and the Septuagint are based on different recensions of the Hebrew text of the book.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP38",
      "id": "ap_NBP38-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("An important aspect of Jeremiah’s textual history is that the book itself records the need for a second edition.")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("It was the ninth month and the king was sitting in the winter apartment with a fire burning in front of him. Whenever Jehudi had read three or four columns of the scroll, the king cut them off with a scribe’s knife and threw them into the firepot, until the entire scroll was burned in the fire. (Jer 36:22-25)")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Whatever historical buffeting the text of Jeremiah experienced, two constants remain clear. First, the contents of the material in Hebrew and Greek, for all of the textual history, remain re"), _c('a', {
    attrs: {
      "id": "page_XXVII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XXVII"
    }
  }, [_vm._v("markably congruent, i.e., there is no evidence of any theological division or differences. Second, in accord with the harmonious content of both texts, no matter of doctrine or life is altered by any of the variants or placements.")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-002"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XXVII"
    }
  }, [_c('b', [_vm._v("Table 1")])])])]), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "40%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MT")])])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("LXX")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  })]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("1-25:13a")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("1-25:13a")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("25:13b-38")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("32:13b-38*")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("26")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("33")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("27")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("34*")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("28")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("35")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("29")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("36*")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("30")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("37*")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("31")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("38")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("32")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("39")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("33")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("40*")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("34")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("41")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("35")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("42")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("36")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("43")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("37")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("44")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("38")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("45")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("39")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("46*")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("40")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("47")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("41")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("48")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("42")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("49")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("43")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("50")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("44")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("51:1-3")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("45")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("51:31-35")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("46:1-26 Egypt")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("26:2-25")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("46:27-28")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("26:27-28")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("47 Philistines")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("29")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("48 Moab")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("31*")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("49:1-6 Ammon")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("30:17-21/22")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("49:7-22 Edom")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("30:1-16")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("49:23-27 Damascus")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("30:29-33")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("49:28-33 Kedar")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("30:23-28")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("49:34-39 Elam")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("25:14-20**")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("50-51 Babylon")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("27-28**")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  })]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  })])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("  *verses lacking")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  })])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("**variation in order")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  })])])])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-027"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XXVII"
    }
  }, [_vm._v("Use of the Old Testament")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XXVII"
    }
  }, [_vm._v("In many respects, the use of the ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Old_Testament"
    }
  }, [_vm._v("Old Testament in the church faces the same challenges that ")]), _c('a', {
    attrs: {
      "id": "page_XXVIII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_XXVIII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Bright_John"
    }
  }, [_vm._v("John Bright described in 1967.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP39",
      "id": "ap_NBP39-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" If the Old Testament is viewed almost exclusively in the category of prediction, the fulfillment renders its purpose complete. Even more problematic is the assumption that the God of the Old Testament is discrete and distant from the “kingdom of God” announced and inaugurated by Jesus. "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_Harnack"
    }
  }, [_vm._v("Adolf von Harnack’s statement starkly captures the unease that many people experience with the Old Testament: “To have cast aside the Old Testament in the second century was an error which the church rightly rejected; to have retained it in the sixteenth century was a fate which the Reformation was not yet able to avoid; but still to keep it after the nineteenth century as a canonical document within Protestantism results from a religious and ecclesial paralysis.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP40",
      "id": "ap_NBP40-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" While this quote seems harsh, it captures the underlying problem in the use of the Old Testament that has marked post-Enlightenment scholarship and too often the church’s life.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The Old Testament provided the vocabulary, conceptual world, grammar and syntax for New Testament Christology. As the semantic field in which Jesus of Nazareth was perceived and understood, it remains foundational for the church’s confession of Jesus as the Christ."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP41",
      "id": "ap_NBP41-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" The Fathers exhibit the exegetical riches that flow from viewing the sacred Scriptures of the Old and New Testament as a beautiful tapestry that, for all of its diversity, displays the one blessed and holy Trinity with inspired clarity.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("This series provides that consensual exegetical tradition that regarded the triune God as the center of both the Old and New Testaments. An observation by John L. Thompson underscores the benefits of following these early exegetical trajectories:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Without a doubt, there is something counterintuitive in suggesting that we don’t fully know what the Bible "), _c('i', [_vm._v("means")]), _vm._v(" until we know something about what the Bible "), _c('i', [_vm._v("has meant")]), _vm._v(". Particularly for Protestants, it may seem rather curious, if not risky, to suggest that a correct understanding of the preeminent authority of the Bible will actually drive us "), _c('i', [_vm._v("toward ")]), _vm._v("a deeper knowledge of Christian tradition and the history of interpretation, not "), _c('i', [_vm._v("away")]), _vm._v(" from it."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NBP42",
      "id": "ap_NBP42-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Thomas Oden has done the church a vast service in retrieving the church’s consensual appropriation and application of biblical texts.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("I wish to thank the Reverend Joshua Haugen and seminarian Seth Mierow for their assistance in gathering material from the Fathers. Special thanks is owed to the Reverend Robert Smith, Electronic Resources Librarian at Concordia Theological Seminary, for his expertise and significant contribution to the headings; to Joel Elowsky for patience, encouragement and expert editing; and to Thomas Oden for the invitation to participate in such a noble and theologically rich project.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fb2ae4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre5.vue
// module id = 78
// module chunks = 0